const React = require('react');
const Link = require('react-router-dom').Link;
const SharedConstants = require('../../../../shared/sharedConstants');

import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export class PortfolioActivityLog extends React.Component{
    constructor(props) {
        super(props);
        this.state={
        }
    }



    render() {
        let dayData = [];
        let lastDay = '';
        let index = -1;
        let idOwner = this.props.idOwner;
        let secondaryOwners = this.props.secondaryOwners;

        for(let logItem of this.props.logData){
            let dateString = new Date(logItem.logTime).toDateString();
            if(dateString === lastDay)
                dayData[index].push(logItem);
            else{
                dayData.push([logItem]);
                lastDay = dateString;
                index++;
            }

        }

        let activityRecords = dayData.map(day => {
            let records = day.map(record => {
                if(
                   (record.actionType === SharedConstants.PortfolioActionType.RemoveEvidence || record.actionType === SharedConstants.PortfolioActionType.RemoveEvidence)
                   && this.props.hideRemovalLogs
                ){
                    return;
                }

                let date = new Date(record.logTime);


                let cardType = null;
                let cardLink = null;
                let createLink = false;
                let bgColor = 'inherit';
                let sponsorText = '';
                switch(record.actionType){
                    case SharedConstants.PortfolioActionType.AddEvidence:
                    case SharedConstants.PortfolioActionType.RemoveEvidence:
                        cardType = SharedConstants.CardType.Evidence;
                        createLink = true;
                        break;

                    case SharedConstants.PortfolioActionType.AddReasoning:
                    case SharedConstants.PortfolioActionType.RemoveReasoning:
                        cardType = SharedConstants.CardType.Reasoning;
                        createLink = true;
                        break;

                   case SharedConstants.PortfolioActionType.IncubatorAddText:
                      bgColor = '#D7F0FF';
                      break;

                   case SharedConstants.PortfolioActionType.AddEvidenceComment:

                      break;

                   case SharedConstants.PortfolioActionType.AddNote:
                      bgColor = '#FFFED4'
                }

               if ((record.actionType != SharedConstants.PortfolioActionType.AddQuestion) && (record.idUser === idOwner || (secondaryOwners && secondaryOwners.includes(record.idUser)))){
                  bgColor = '#D7F0FF';
                  sponsorText = `(Sponsor)`;
               }

                if(createLink && this.props.linkBase){
                    cardLink = this.props.linkBase +
                        (this.props.linkBase.includes('?') ? '&' : '?') +
                        'cardType=' + cardType +
                        '&idCard=' + record.idTarget +
                        '&cModalOpen=1';
                }

                let messageText = () => {
                    if(cardLink){
                        return(
                            <Link to={cardLink} className='dashboard-row-body-content' onClick={() => this.props.linkFunction(cardType)}>
                                {SharedConstants.PortfolioActionText[record.actionType] + record.title}
                            </Link>
                        )
                    }

                    return(
                        <div className="msg-text">{SharedConstants.PortfolioActionText[record.actionType] + record.title}</div>
                    )
                };

                let tooltipTitle = (title) => {
                    return (
                       <React.Fragment>
                          <div style={{ fontSize: SharedConstants.TooltipValue.FontSize, lineHeight: SharedConstants.TooltipValue.LineHeight }}>
                             {title}
                          </div>
                       </React.Fragment>
                    )
                 };

                return(
                    <div key={record.logTime + '_' + record.actionType + '_' + record.idTarget} style={{background: bgColor}}>
                        <div className="msg-time">{date.toLocaleTimeString()}</div>
                        <div className="msg-body">
                            <div className="avatar" />
                           {
                              record.voteType === SharedConstants.VoteType.UpVote
                                 ?
                                 <Tooltip title={tooltipTitle(`Sponsor Has Asked For More Like This`)}>
                                    <IconButton
                                       className={'btn-top-bar-icon'}
                                       aria-label={`Bet on ${String.fromCharCode(181)}Pub`}
                                       onClick={() => this.setState({showPopup:true})}
                                    >
                                       <FontAwesomeIcon className={'btn-favorite'} icon={['far',"lightbulb"]} size={'1x'} />
                                    </IconButton>
                                 </Tooltip>
                                 : ''
                           }
                            <div className="msg">
                                <div className="msg-author">{record.firstName} {record.lastName} {sponsorText}</div>
                                {messageText()}
                            </div>
                       </div>
                    </div>
                )
            });

            return(
                <div key={day[0].logTime} className="activity-module">
                    <div className="activity-date">{new Date(day[0].logTime).toDateString()}</div>
                    <div className="activity-msg">
                        {records}
                    </div>
                </div>
            )
        });

        return activityRecords;
    }
}